import { BaseLayout } from "./BaseLayout";

export class ParentChildContentLayout extends BaseLayout {
    private static layout = require("./Templates/ParentChild.html").default;

    apply(): void {
        this.setContentLayout(ParentChildContentLayout.layout);
    }
}
